import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'
import Link from 'components/Link'

import classes from './CloseButton.module.scss'

/** @type {import("./types").default} */
const CloseButton = ({ onClick = () => {}, href, invertColors = false, size }) => {
  return (
    <Link className={clsx('CloseButton', classes.link)} onClick={onClick} href={href}>
      <div className={classes.container}>
        <Icon
          data-testid="close-button-icon"
          icon="times"
          size={size}
          className={invertColors ? classes.iconColorsInverted : classes.iconColors}
        />
      </div>
    </Link>
  )
}

export default React.memo(CloseButton)
